import { useGridApiContext } from "@mui/x-data-grid-pro";
import { InfoButton } from "../components/ModelInfoButton";

const DisplayStateButton = (props) => {
  const apiRef = useGridApiContext();
  const state = apiRef.current.exportState();
  const columns = apiRef.current.getAllColumns();

  return <InfoButton {...props} data={{ state, columns }} />;
};

export default DisplayStateButton;
